export default "__VITE_ASSET__Dj9zGPge__"